module.exports = __webpack_public_path__ + "media/images/mamari/wowma/about-title-ba51d4e0e9df5f999e5be4a56209bc94.png";